import "./App.css";
import CommercialSite from "./CommercialSite";

function App() {
  return (
    <div className="commercial-app-shell">
      <CommercialSite />
    </div>
  );
}

export default App;
